<template>
    <div class="chat">
        <div v-if="processing">
            <vue-simple-spinner ></vue-simple-spinner>
        </div>
        <div v-else>
            <div v-if="processed">
                <div v-if="showChat">
                    <div class="live__chat-box">
                        <div v-for="message in messages">
                            <div class='live__chat-mes' v-bind:class="isMyMessage(message)">
                                <p class='live__chat-name' v-html="message.nick"></p>
                                <p class='live__chat-text' v-html="message.content"></p>
                                <button v-if="is_admin" class='live__chat-delete' v-on:click="deleteMessage(message.id)">Usuń</button>
                                <span class="live__chat-time" v-html="message.time"></span>
                            </div>
                        </div>
                    </div>
                    <input v-model="content" class="live__chat-input" type="text" @keyup.enter="sendMessage" placeholder="Wpisz swoją wiadomość">
                    <div class="live__chat-button">
                        <button v-on:click="sendMessage" class="live__chat-btn btn btn-primary">Wyślij</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import Spinner from "vue-simple-spinner";

export default {
    props: ['webinar_uuid', 'user_id', 'is_admin', 'chat_name'],
    components: {
        Spinner
    },
    data() {
        return {
            content: null,
            processed: false,
            processing: true,
            showChat: false,
            messages: []
        }
    },
    mounted() {
        this.submitName();
        this.startListening();
    },
    computed: {
    },
    methods: {
        isMyMessage(message) {
            return message.user_id == this.user_id ? 'live__chat-mes-my' : '';
        },
        getChatName() {
            axios.get('/api/chat/get-name')
            .then(response => {
                this.chatName = response.data.data.name;
                this.processed = true;
                this.processing = false;
            });
        },
        startListening() {
            self = this;
            Echo.private('chat.' + this.webinar_uuid).listen('MessageSent', function (e) {
                self.messages.unshift(e.message);
            });
            Echo.private('chat.' + this.webinar_uuid).listen('MessageDelete', function (e) {
                self.messages.splice(self.messages.findIndex(function(i){
                    return i.id === e.message.id;
                }), 1);
                self.processing = false;
            });
        },
        submitName() {
            axios.post('/api/chat/set-name', {
                name: this.chat_name
            })
            .then(response => {
                this.processed = true;
                this.processing = false;
                this.fetchMessages();
            }).catch(error => {
                this.$notify({
                    'group': 'foo',
                    'type': 'error',
                    'title': error.response.data.errors.name[0]
                });
            });
        },
        fetchMessages() {
            axios.get('/api/chat', {
                params: {
                    webinar_uuid: this.webinar_uuid
                }
            }).then(response => {
                this.messages = response.data.data;
                this.showChat = true;
            }).catch(errorResponse => {
                this.$functions.catchApiErrors(errorResponse, this);
            })
        },
        sendMessage() {
            axios.post('/api/chat/send', {
                content: this.content,
                webinar_uuid: this.webinar_uuid
            })
            .then(response => {
                this.content = null;
            }).catch(errorResponse => {
                this.$functions.catchApiErrors(errorResponse, this);
            });
        },
        deleteMessage(messageId) {
            this.processing = true;
            axios.delete('/api/chat/' + messageId)
            .catch(errorResponse => {
                this.processing = false;
                this.$functions.catchApiErrors(errorResponse, this);
            });
        },
    }
}
</script>
